// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"index-module--contentWrapper--3QuXC"};